import { useCurrentUser } from "../hooks/useCurrentUser";

/**
 * Custom hook to get the OIDC roles of the current user.
 * @returns {string[]} An array of roles.
 */
export const useOidcRoles = (): string[] => {
  const currentUser = useCurrentUser();
  const oidcRoles = currentUser?.oidcRoles || [];
  return Array.isArray(oidcRoles) ? oidcRoles : [];
};

/**
 * Custom hook to check if a specific role is active.
 * @param {string} role - The role to check.
 * @returns {boolean} Whether the role is active.
 */
export const useHasRole = (role: string): boolean => {
  const roles = useOidcRoles();
  return roles.includes(role);
};
